import React, { Component, ErrorInfo, ReactNode } from 'react';
import NetworkError from './pages/Errors/NetworkError';

interface Props {
  children?: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    error: null,
  };

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    this.state.error = error;
  }

  public render() {
    if (this.state.hasError) {
      return (
        <NetworkError
          isNetworkError={this.state.error?.message === 'Network Error'}
        />
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
